const MAX_TELEMETRY_AGE_MS = 90 * 60 * 1000;
const MAX_FUTURE_SKEW_MS = 5 * 60 * 1000;
const MAX_SUCCESS_AGE_MS = 90 * 60 * 1000;

export function getSnapshotReportingDate(value) {
  if (typeof value !== "string") return null;
  const date = value.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return null;
  const parsed = new Date(`${date}T00:00:00Z`);
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === date ? date : null;
}

export function isTelemetryCurrent(telemetry, snapshotAsOf, now = Date.now()) {
  if (!telemetry || getSnapshotReportingDate(telemetry.snapshot_as_of) !== getSnapshotReportingDate(snapshotAsOf)) return false;
  if (!getSnapshotReportingDate(snapshotAsOf)) return false;
  const generatedAt = Date.parse(telemetry.generated_at);
  if (!Number.isFinite(generatedAt)) return false;
  const age = now - generatedAt;
  return age >= -MAX_FUTURE_SKEW_MS && age <= MAX_TELEMETRY_AGE_MS;
}

export function getOperationalStatus(telemetry, component, now = Date.now()) {
  const value = telemetry?.[component];
  if (!value || !isTelemetryCurrent(telemetry, telemetry.snapshot_as_of, now)) {
    return { label: "Unknown", tone: "unknown", detail: "No current, matching telemetry is available." };
  }

  if (value.latest_run?.status === "failed" || value.service_state === "failed") {
    return { label: "Failed", tone: "error", detail: "The latest reported service or run failed." };
  }
  if (value.latest_run?.status === "running" || value.service_state === "active") {
    return { label: "Running", tone: "live", detail: "The service is currently reported active." };
  }
  if (value.timer_state === "inactive") {
    return { label: "Paused", tone: "paused", detail: "The schedule is reported inactive." };
  }
  if (value.timer_state !== "active" || !value.last_success_at) {
    return { label: "Unknown", tone: "unknown", detail: "The schedule or last successful run is not confirmed." };
  }

  const lastSuccessAt = Date.parse(value.last_success_at);
  if (!Number.isFinite(lastSuccessAt) || now - lastSuccessAt > MAX_SUCCESS_AGE_MS || lastSuccessAt > now + MAX_FUTURE_SKEW_MS) {
    return { label: "Delayed", tone: "warning", detail: "No recent successful run is reported." };
  }
  return { label: "Healthy", tone: "healthy", detail: "A recent successful run and active schedule are reported." };
}
